import React, { useRef, useState } from "react";
import { useLanguage } from "../../config/LanguageContext";
import LanguageModal from "../nav/LanguageModal";
import { TbWorld } from "react-icons/tb";
import NavMobileMenu from "./NavMobileMenu";

function NavActions({
  currentLanguage,
  showDropdown,
  setShowDropdown,
  handleBookDemoClick,
}) {
  const { handleLanguageChange } = useLanguage();
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const buttonRef = useRef(null);

  const toggleLanguageModal = () => {
    setShowLanguageModal((prev) => !prev);
  };

  return (
    <div className="nav-right-side">
      <button
      ref={buttonRef}
        className="nav-lang-button"
        onClick={(e) => {
          e.stopPropagation();
          toggleLanguageModal();
        }}
      >
        <TbWorld size={20} />
      </button>
      {showLanguageModal && (
        <LanguageModal
          currentLanguage={currentLanguage}
          handleLanguageChange={handleLanguageChange}
          toggleLanguageModal={toggleLanguageModal}
          triggerRef={buttonRef}
        />
      )}
      <button
        onClick={handleBookDemoClick}
        className={`cta-button nav-button ${showMenu ? "hidden" : ""}`}
      >
        {
          {
            en: "Request a demo",
            fr: "Réserver une démo",
            de: "Demo anfordern",
            es: "Solicitar una demo",
          }[currentLanguage]
        }
      </button>

      <NavMobileMenu
        setShowMenu={setShowMenu}
        setShowDropdown={setShowDropdown}
        showDropdown={showDropdown}
      />
    </div>
  );
}

export default NavActions;
